module.exports = __webpack_public_path__ + "img/user-management.82e1deb8.png";